import MathUtils from "@/utils/MathUtils"

function LatLongBounds(topLeft, bottomRight) {
    this.topLeft = topLeft.clone();
    this.bottomRight = bottomRight.clone();
}

LatLongBounds.prototype = {
    /**
     * Clones the location
     * @return {Location} Clone of the location
     */
    clone: function() {
        return new LatLongBounds(this.topLeft, this.bottomRight);
    },

    contains: function(location) {
        return MathUtils.contains(location.latitude, this.minLat(), this.maxLat()) && MathUtils.contains(location.longitude, this.minLong(), this.maxLong());
    },

    minLat: function() {
        return Math.min(this.topLeft.latitude, this.bottomRight.latitude);
    },

    minLong: function() {
        return Math.min(this.topLeft.longitude, this.bottomRight.longitude);
    },

    maxLat: function() {
        return Math.max(this.topLeft.latitude, this.bottomRight.latitude);
    },

    maxLong: function() {
        return Math.max(this.topLeft.longitude, this.bottomRight.longitude);
    }
};

export default LatLongBounds;